module.exports = __webpack_public_path__ + "img/image3.871ef394.png";